import {StringUtils} from "../../../../utils/data/string/StringUtils";
import type {IDateFieldSettingsDefinition} from "../../../modules/settings/modules/field/datatypes/DateFieldSettings";
import type {IInputPropsV5} from "../../../widgets/input/clicktoedit/InputUtils";
import {TextInputV5} from "./TextInputV5";

export const EmailInputV5 = (props: IInputPropsV5<IDateFieldSettingsDefinition>) => {
	const {value, onInput, onBlur, disabled, onChange, onClick} = props;

	const handleBlur = () => {
		onBlur?.();
	};

	const getErrorMessage = (value: string): string => {
		return !value || StringUtils.emailValidator(value) ? "" : "Enter a valid Email!";
	};

	return (
		<div className="hbox field-input-container">
			<TextInputV5
				value={value}
				onInput={onInput}
				onChange={onChange}
				onBlur={handleBlur}
				autoFocus={false}
				disabled={disabled}
				getErrorMessage={getErrorMessage}
				onClick={onClick}
			/>
		</div>
	);
};
